import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <section className="min-h-[70vh] grid place-items-center bg-brand-cream">
      <SEO
        title="Page Not Found (404) — AM Group of Education"
        description="The page you're looking for doesn't exist. Return to the AM Group of Education homepage to explore school, competitive, government, language and IT courses."
        noindex
      />
      <div className="text-center px-6" data-testid="not-found">
        <div className="display-serif text-7xl font-extrabold text-brand-dark">404</div>
        <h1 className="mt-2 display-serif text-2xl font-bold text-brand-dark">Page Not Found</h1>
        <p className="mt-3 text-brand-mute">The page you&apos;re looking for has graduated already.</p>
        <div className="mt-6 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="btn-primary">Back Home <i className="fa-solid fa-house" /></Link>
          <Link to="/school-courses" className="btn-outline">Explore Courses <i className="fa-solid fa-arrow-right" /></Link>
        </div>
      </div>
    </section>
  );
}
